// BugList.js

import React, { useContext, useEffect, useState } from 'react';
import { Button, Modal } from "react-bootstrap";
import Skeleton from '@mui/material/Skeleton';
// import BugCard from './BugCard';
import { Link } from 'react-router-dom';
import { AccountCircle } from '@material-ui/icons';
import axios from 'axios';
import ENDPOINT from '../../context/EndPoint';
import SecurityHeaders from '../../context/SecurityHeaders';
import HackingInternshipBatchItem from './HackingInternshipBatchItem';
import SnackbarToast from '../../components/toasts/SnackbarToast';
import { useDispatch } from 'react-redux';
import { useActionsContext } from '../../context/ActionsContext';
import { AuthContext } from '../../context/AuthContext'

const HackInternshipBatch = () => {
    const dispatch = useDispatch()
    const [formData, setFormData] = useState({
        batch_name: "",
        start_date: "",
        end_date: "",
        morning_slot: "",
        afternoon_slot: "",
        evening_slot: "",
    });
    const [modelShow, setModelShow] = useState(false);
    const [open, setOpen] = useState({
        open: false,
        message: '',
        type: ''

    });
    
    const { user } = useContext(AuthContext);
    const [message, setMessage] = useState("");
    const [batches, setBatches] = useState([])
    const { rowsPerPage, setRowsPerPage } = useActionsContext(); 
    

    const getBatches = async () => {
        dispatch({type:'LOADING'})
        const data = new FormData()
    data.append('session', user.SessionId)
    data.append('limit', rowsPerPage)
        try {
            const response = await axios.post(ENDPOINT + "get-hacking-internship-batch.php", data, SecurityHeaders);
            if (response.data.status === 'success') {
                setBatches(response.data.data);
                dispatch({type:'DONE_LOADING'})

            }
            else {
        
                dispatch({type:'ERROR', payload:'Error occurred while loading'})
            }
        } catch (error) {
            dispatch({type:'ERROR', payload:error.message})
        }
    };
    useEffect(() => {
        getBatches();
    }, [rowsPerPage]);

    // Handle input change
    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    // Handle form submission
    const handleSubmit = async (e) => {
        dispatch({type:'LOADING'})
        e.preventDefault();

        const data = new FormData()
        data.append('batch_name', formData.batch_name);
        data.append('end_date', formData.end_date);
        data.append('start_date', formData.start_date);
        data.append('morning_slot', formData.morning_slot);
        data.append('afternoon_slot', formData.afternoon_slot);
        data.append('evening_slot', formData.evening_slot);


     try{
        const response = await axios.post(ENDPOINT + "add-hacking-internship-batch.php", data, SecurityHeaders)

        if (response.data.status === "success") {
            dispatch({type:'DONE_LOADING'})
            setMessage(response.data.message);
            setModelShow(false);
            setOpen({ open: true, message: response.data.message, type:'success' })
            getBatches()

            setFormData({
                batch_name: "",
                start_date: "",
                end_date: "",
                morning_slot: "",
                afternoon_slot: "",
                evening_slot: "",
            });
        }
        else {
            setMessage(response.data.message);
            dispatch({type:'ERROR',payload:response.data.message})
        }
     }
     catch(error){
        setMessage(error.response.data.message)
        dispatch({type:'ERROR',payload:error.message})
        setOpen(true)
     }
    };

    return (
        <div className="container">
    <SnackbarToast open={open} handleClose={()=>setOpen((pre)=>({...pre,open:false}))} />


            <div className='d-flex justify-content-end'>
                <Button variant="primary" onClick={() => setModelShow(true)}>
                    Add batch
                </Button>
            </div>

            <Modal show={modelShow} onHide={() => setModelShow(false)}>
                <Modal.Body>
                    <div className="container mt-4">
                        <h2 className="mb-3">Insert Internship Batch</h2>
                        {message && <div className="alert alert-info">{message}</div>}

                        <form onSubmit={handleSubmit}>
                            <div className="mb-3">
                                <label className="form-label">Batch Name</label>
                                <input type="text" name="batch_name" className="form-control" value={formData.batch_name} onChange={handleChange} required />
                            </div>

                            <div className="mb-3">
                                <label className="form-label">Start Date</label>
                                <input type="date" name="start_date" className="form-control" value={formData.start_date} onChange={handleChange} required />
                            </div>

                            <div className="mb-3">
                                <label className="form-label">End Date</label>
                                <input type="date" name="end_date" className="form-control" value={formData.end_date} onChange={handleChange} required />
                            </div>

                            <div className="mb-3">
                                <label className="form-label">Morning Slot</label>
                                <select type="text" name="morning_slot" className="form-control" value={formData.morning_slot} onChange={handleChange} >
                                    <option value="">Select Slot</option>
                                    <option value="Almost filled">Almost filled</option>
                                    <option value="Few seats left">Few seats left                                    </option>
                                    <option value="Available">Available</option>
                                </select>
                            </div>

                            <div className="mb-3">
                                <label className="form-label">Afternoon Slot</label>
                                <select type="text" name="afternoon_slot" className="form-control" value={formData.afternoon_slot} onChange={handleChange} >
                                    <option value="">Select Slot</option>
                                    <option value="Almost filled">Almost filled</option>
                                    <option value="Few seats left">Few seats left                                    </option>
                                    <option value="Available">Available</option>
                                </select>
                            </div>

                            <div className="mb-3">
                                <label className="form-label">Evening Slot</label>
                                <select type="text" name="evening_slot" className="form-control" value={formData.evening_slot} onChange={handleChange} >
                                    <option value="">Select Slot</option>
                                    <option value="Almost filled">Almost filled</option>
                                    <option value="Few seats left">Few seats left                                    </option>
                                    <option value="Available">Available</option>
                                </select>
                            </div>

                            <button type="submit" className="btn btn-primary">Submit</button>
                        </form>
                    </div>
                </Modal.Body>
            </Modal>


            <div className="d-flex justify-content-center ">
                <div className="col-lg-12 d-flex flex-wrap p-3 ">
                    {batches ? (
                        batches.map((batch, index) => (
                            <HackingInternshipBatchItem item={batch} key={index} reload={getBatches} />
                        ))
                    ) : (
                        <>
                            <div className='col-lg-3 p-2'>
                                <Skeleton variant="rectangular" className="col-12" height={100} />
                            </div>
                            <div className='col-lg-3 p-2'>
                                <Skeleton variant="rectangular" className="col-12" height={100} />
                            </div>
                            <div className='col-lg-3 p-2'>
                                <Skeleton variant="rectangular" className="col-12" height={100} />
                            </div>
                            <div className='col-lg-3 p-2'>
                                <Skeleton variant="rectangular" className="col-12" height={100} />
                            </div>
                            <div className='col-lg-3 p-2'>
                                <Skeleton variant="rectangular" className="col-12" height={100} />
                            </div>
                            <div className='col-lg-3 p-2'>
                                <Skeleton variant="rectangular" className="col-12" height={100} />
                            </div>
                        </>
                    )}
                </div>
            </div>
        </div>
    );
};

export default HackInternshipBatch;